module.exports = __webpack_public_path__ + "static/media/YM54_4.c61b6c91.jpg";